"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7402],{

/***/ 20518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'CloseOutlined');

/***/ }),

/***/ 42761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');

/***/ }),

/***/ 18963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var _require = __webpack_require__(14671),
    create = _require.create;

var useNavbarStore = create(function (set) {
  return {
    openNavbar: true,
    setToggleNavbar: function setToggleNavbar(openNavbar) {
      set({
        openNavbar: openNavbar
      });
    },
    setOpenNavbar: function setOpenNavbar() {
      set({
        openNavbar: true
      });
    },
    setCloseNavbar: function setCloseNavbar() {
      set({
        openNavbar: false
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useNavbarStore);

/***/ }),

/***/ 53702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_CloseOutlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20518);
/* harmony import */ var _mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42761);
/* harmony import */ var _context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78525);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var SearchComponent = function SearchComponent(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onSearch = _ref.onSearch,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder,
      _ref$gradientBorder = _ref.gradientBorder,
      gradientBorder = _ref$gradientBorder === void 0 ? false : _ref$gradientBorder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? 'bg-container-bg-primary' : _ref$bgColor,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      justClick = _ref.justClick;
  var inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useBrandConfigStore = (0,_context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (state) {
    return state.config.themeConfig.container;
  }),
      colors = _useBrandConfigStore.colors;

  var searchHandler = function searchHandler(e) {
    e.preventDefault();
    if (onSearch) onSearch();
  };

  var clearInputHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (onChange) {
      onChange('');
    }

    if (inputRef.current) {
      inputRef.current.focus();
    }

    if (onSearch) onSearch();
  }, [onChange, onSearch]);

  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  var onJustClick = function onJustClick() {
    if (justClick) {
      justClick();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("form", {
      onSubmit: searchHandler,
      className: "flex col-span-12 w-full h-9 font-semibold rounded-lg",
      onClick: onJustClick,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: `
					flex w-full h-full rounded-lg items-center relative
					${gradientBorder ? 'game-search-input-wrapper' : 'border'}
				`,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input", {
          ref: inputRef,
          type: "text",
          value: value,
          className: `
						w-full h-full rounded-lg text-sm outline-none border-transparent focus:border-transparent focus:ring-0 px-3 text-container-color-primary
						placeholder:font-light
						${gradientBorder ? `${bgColor}` : 'bg-inherit'}
						`,
          placeholder: placeholder,
          disabled: disabled,
          readOnly: readOnly,
          "aria-label": "Search Input",
          onChange: onChangeHandler
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "absolute right-0 flex items-center space-x-2",
          children: [value && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material_CloseOutlined__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "text-gray-500 cursor-pointer hover:text-gray-700",
            onClick: clearInputHandler,
            "aria-label": "Clear Search"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
            type: "submit",
            className: "px-2",
            "aria-label": "Search",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_icons_material_Search__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              style: {
                color: colors.primary
              }
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SearchComponent);

/***/ }),

/***/ 5231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Card_CardGame; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atom/LabelCard/LabelCardImage2/index.jsx


var _excluded = ["labelName", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LabelCardImage2 = function LabelCardImage2(_ref) {
  var labelName = _ref.labelName,
      className = _ref.className,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var list = {
    trendingLabel: '/images/label-card/label_trending.png',
    hotLabel: '/images/label-card/label_hot.png',
    newLabel: '/images/label-card/label_new.png'
  };
  var imagePath = list === null || list === void 0 ? void 0 : list[labelName];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", _objectSpread({
      src: imagePath,
      className: className
    }, props))
  });
};

/* harmony default export */ var LabelCard_LabelCardImage2 = (LabelCardImage2);
// EXTERNAL MODULE: ./hooks/useGameActionHook.hook.js + 1 modules
var useGameActionHook_hook = __webpack_require__(95266);
// EXTERNAL MODULE: ./src/helpers/custom-image-loader.js
var custom_image_loader = __webpack_require__(99125);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/cn.js
var cn = __webpack_require__(8957);
;// CONCATENATED MODULE: ./src/components/molecules/Card/CardGame/index.jsx








var CardGame = function CardGame(_ref) {
  var game = _ref.game,
      cardType = _ref.cardType,
      className = _ref.className;

  var _useGameActionHook = (0,useGameActionHook_hook/* default */.Z)(),
      gameRouterPush = _useGameActionHook.gameRouterPush;

  var handleGameClick = function handleGameClick(mode) {
    // console.log('ke clikc : ', game);
    gameRouterPush(mode, game);
  }; // Choose the component based on cardType


  switch (cardType) {
    case 'hot':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(HotCard, {
        game: game,
        onClick: handleGameClick,
        className: className
      });

    case 'loading':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingCard, {});

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StandardCard, {
        game: game,
        onClick: handleGameClick,
        className: className
      });
  }
};

var StandardCard = function StandardCard(_ref2) {
  var game = _ref2.game,
      _onClick = _ref2.onClick,
      className = _ref2.className;
  // let darkVibrant = game?.co?.[3];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (0,cn.cn)('group relative aspect-[3/4] overflow-hidden hover:bg-opacity-80 transition-all duration-300 ease-in-out cursor-pointer w-full', className),
      onMouseEnter: function onMouseEnter(e) {
        return e.stopPropagation();
      } // onClick={() => !game?.da && onClick(0)}
      ,
      onClick: function onClick() {
        return _onClick(0);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GameImage, {
          game: game
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GameTitle, {
          game: game
        })]
      })
    })
  });
};

var HotCard = function HotCard(_ref3) {
  var game = _ref3.game,
      _onClick2 = _ref3.onClick,
      className = _ref3.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (0,cn.cn)('group relative aspect-[3/4] overflow-hidden hover:bg-opacity-80 transition-all duration-300 ease-in-out cursor-pointer', className),
    onMouseEnter: function onMouseEnter(e) {
      return e.stopPropagation();
    },
    onClick: function onClick() {
      return !(game !== null && game !== void 0 && game.da) && _onClick2(0);
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex-col aspect-[3/4] bg-inherit",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex-1 aspect-square",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex w-full justify-between absolute top-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelCard_LabelCardImage2, {
            labelName: 'trendingLabel',
            className: 'z-10 w-16 object-contain'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelCard_LabelCardImage2, {
            labelName: 'newLabel',
            className: 'z-10 w-8'
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          id: `${game === null || game === void 0 ? void 0 : game.pi}-${game === null || game === void 0 ? void 0 : game.pn}`,
          src: (game === null || game === void 0 ? void 0 : game.img) || '/images/games/404.jpg',
          loader: custom_image_loader/* customImageLoader */.o,
          layout: "fill",
          objectFit: "cover",
          alt: game === null || game === void 0 ? void 0 : game.gn,
          loading: "lazy"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GameTitle, {
        game: game
      })]
    }), (game === null || game === void 0 ? void 0 : game.da) && /*#__PURE__*/(0,jsx_runtime.jsx)(GameOverlay, {
      game: game,
      gameRouterPush: _onClick2
    })]
  });
};

var LoadingCard = function LoadingCard() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "animate-pulse flex flex-col aspect-[3/4] bg-inherit gap-1",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "aspect-square bg-slate-500 rounded-lg"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex w-full flex-col items-center justify-center gap-1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-2 bg-slate-500 rounded-full"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-2 bg-slate-500 rounded-full"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-2 bg-slate-500 rounded-full"
      })]
    })]
  });
}; // Reusable components


var GameImage = function GameImage(_ref4) {
  var game = _ref4.game;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative aspect-square w-full h-full",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      id: `${game === null || game === void 0 ? void 0 : game.pi}-${game === null || game === void 0 ? void 0 : game.pn}`,
      src: (game === null || game === void 0 ? void 0 : game.img) || '/images/games/404.jpg',
      loader: custom_image_loader/* customImageLoader */.o,
      layout: "fill",
      objectFit: "cover",
      alt: game === null || game === void 0 ? void 0 : game.gn,
      loading: "lazy"
    })
  });
};

var GameTitle = function GameTitle(_ref5) {
  var game = _ref5.game;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex-1 flex items-center justify-center text-center text-container-color-primary p-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-xs break-words font-semibold leading-none line-clamp-2 text-ellipsis",
      children: game === null || game === void 0 ? void 0 : game.gn
    })
  });
};

var GameOverlay = function GameOverlay(_ref6) {
  var game = _ref6.game,
      gameRouterPush = _ref6.gameRouterPush,
      darkVibrant = _ref6.darkVibrant;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "aspect-square",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OverlayButton, {
      position: "top-0",
      background: darkVibrant || '#333',
      onClick: function onClick() {
        return gameRouterPush(0, game);
      },
      label: "Play"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OverlayButton, {
      position: "bottom-0",
      buttonClassName: "bg-black/50",
      background: darkVibrant || '#333',
      onClick: function onClick() {
        return gameRouterPush(1, game);
      },
      label: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Demo"
      })
    })]
  });
};

var OverlayButton = function OverlayButton(_ref7) {
  var position = _ref7.position,
      background = _ref7.background,
      onClick = _ref7.onClick,
      label = _ref7.label,
      buttonClassName = _ref7.buttonClassName;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (0,cn.cn)('absolute left-0 w-full h-1/2 flex items-center justify-center text-lg transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100', position),
    style: {
      background: background
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (0,cn.cn)('w-full h-full text-container-color-primary', buttonClassName),
      onClick: onClick,
      children: label
    })
  });
}; // const CardGame = ({ game, cardType, className }) => {
// 	let darkVibrant = game?.co?.[3];
// 	const { gameRouterPush } = useGameActionHook();
// 	if (cardType === 'loading') {
// 		return (
// 			<>
// 				<div className="animate-pulse flex flex-col aspect-[3/4] bg-inherit gap-1">
// 					<div className="aspect-square bg-slate-500 rounded-lg"></div>
// 					<div className="flex w-full flex-col items-center justify-center gap-1">
// 						<div className="w-full h-2 bg-slate-500 rounded-full"></div>
// 						<div className="w-full h-2 bg-slate-500 rounded-full"></div>
// 						<div className="w-full h-2 bg-slate-500 rounded-full"></div>
// 					</div>
// 				</div>
// 			</>
// 		);
// 	}
// 	if (cardType === 'hot') {
// 		return (
// 			<>
// 				<div
// 					className="group relative aspect-[3/4] overflow-hidden hover:bg-opacity-80 transition-all duration-300 ease-in-out cursor-pointer"
// 					onMouseEnter={(e) => e.stopPropagation()}
// 					onClick={() => {
// 						if (!game?.da) {
// 							gameRouterPush(false);
// 						}
// 					}}>
// 					<div className="flex-col aspect-[3/4] bg-inherit">
// 						<div className="relative flex-1 aspect-square">
// 							<div className="flex w-full justify-between absolute top-0">
// 								<LabelCardImage2
// 									labelName={'trendingLabel'}
// 									className={'z-10 w-16 object-contain'}
// 								/>
// 								<LabelCardImage2 labelName={'newLabel'} className={'z-10 w-8'} />
// 							</div>
// 							<img
// 								id={`${game?.img}`}
// 								src={game?.img ? game?.img : '/images/games/404.jpeg'}
// 								alt={game?.gameName}
// 								className="w-full h-full object-cover"
// 								loading="lazy"
// 							/>
// 						</div>
// 						<div className="flex flex-col items-center justify-center p-1">
// 							<p className="flex-1 w-full text-xs text-center break-words line-clamp-2 font-semibold leading-none text-container-color-primary">
// 								{game?.pn}
// 							</p>
// 						</div>
// 					</div>
// 					{game?.da && (
// 						<>
// 							<div className="aspect-square">
// 								<div
// 									className="absolute top-0 left-0 w-full h-1/2 flex items-center justify-center text-lg transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100"
// 									style={{ background: darkVibrant || '#333333' }}>
// 									<button
// 										className="w-full h-full text-container-color-primary"
// 										onClick={() => {
// 											gameRouterPush(false);
// 										}}>
// 										Play
// 									</button>
// 								</div>
// 								<div
// 									className="absolute bottom-0 left-0 w-full h-1/2 flex items-center justify-center text-lg transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100"
// 									style={{ background: darkVibrant || '#333333' }}>
// 									<button
// 										className="w-full h-full text-container-color-primary bg-black/50"
// 										onClick={() => {
// 											gameRouterPush(true);
// 										}}>
// 										<span>Demo</span>
// 									</button>
// 								</div>
// 							</div>
// 						</>
// 					)}
// 				</div>
// 			</>
// 		);
// 	}
// 	return (
// 		<>
// 			<div
// 				className={cn(
// 					'group relative aspect-[3/4] overflow-hidden hover:bg-opacity-80 transition-all duration-300 ease-in-out cursor-pointer w-52',
// 					className
// 				)}
// 				onMouseEnter={(e) => e.stopPropagation()}
// 				onClick={() => {
// 					if (!game?.da) {
// 						gameRouterPush(0, game);
// 						// onClickGame(false);
// 					}
// 				}}>
// 				<div className="w-full h-full flex flex-col">
// 					<div className="relative aspect-square">
// 						<Image
// 							id={`${game?.pi}-${game?.pn}`}
// 							src={game?.img ? game?.img : '/images/games/404.jpg'}
// 							loader={customImageLoader}
// 							layout="fill"
// 							objectFit="contain"
// 							alt={game?.gn}
// 							// className="w-full object-cover aspect-square"
// 							loading="lazy"
// 						/>
// 					</div>
// 					<div className="flex-1 flex items-center justify-center text-center text-container-color-primary p-1">
// 						<p className="text-xs break-words font-semibold leading-none line-clamp-2 text-ellipsis">
// 							{game?.gn}
// 						</p>
// 					</div>
// 				</div>
// 				{game?.da && (
// 					<>
// 						<div className="aspect-square">
// 							<div
// 								className="absolute top-0 left-0 w-full h-1/2 flex items-center justify-center text-lg transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100"
// 								style={{ background: darkVibrant || '#333333' }}>
// 								<button
// 									className="w-full h-full text-container-color-primary"
// 									onClick={() => {
// 										gameRouterPush(0, game);
// 										// onClickGame(false);
// 									}}>
// 									Play
// 								</button>
// 							</div>
// 							<div
// 								className="absolute bottom-0 left-0 w-full h-1/2 flex items-center justify-center text-lg transition-opacity duration-300 ease-in-out opacity-0 group-hover:opacity-100"
// 								style={{ background: darkVibrant || '#333333' }}>
// 								<button
// 									className="w-full h-full text-container-color-primary bg-black/50"
// 									onClick={() => {
// 										gameRouterPush(1, game);
// 										// onClickGame(true);
// 									}}>
// 									<span>Demo</span>
// 								</button>
// 							</div>
// 						</div>
// 					</>
// 				)}
// 			</div>
// 		</>
// 	);
// };


/* harmony default export */ var Card_CardGame = (CardGame);

/***/ }),

/***/ 97402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_GameSearchPageComponent2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(51526);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 31 modules
var motion = __webpack_require__(70798);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseOutlined.js
var CloseOutlined = __webpack_require__(20518);
// EXTERNAL MODULE: ./utils/framerMotion.utils.js
var framerMotion_utils = __webpack_require__(75774);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/modal/SlideModal.jsx







var SlideModalComponent = function SlideModalComponent(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Slide' : _ref$title,
      _ref$slideMode = _ref.slideMode,
      slideMode = _ref$slideMode === void 0 ? 'fromRight' : _ref$slideMode,
      children = _ref.children;
  (0,react.useEffect)(function () {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return function () {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  var onCloseHandler = function onCloseHandler() {
    if (onClose) {
      onClose();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex justify-center items-center fixed inset-0 w-full h-full xl:bg-black/70 z-500",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full max-w-7xl h-full xl:h-5/6 overflow-y-auto xl:rounded-lg",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
              initial: "closed",
              animate: "open",
              exit: "closed",
              variants: framerMotion_utils/* animationVariants */.j[slideMode],
              transition: {
                duration: 0.5,
                ease: 'easeInOut'
              },
              onAnimationComplete: function onAnimationComplete() {
                return !isOpen && onClose();
              },
              className: "bg-container-bg-primary h-full w-full overflow-y-auto",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center p-2 h-14 text-text-color-primary",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "text-lg font-semibold gradient-text-color",
                  children: title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {
                  className: "cursor-pointer text-container-color-primary",
                  onClick: onCloseHandler
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex w-full justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "p-2 w-full container-body",
                  children: children
                })
              })]
            })
          })
        })
      })
    })
  });
};

/* harmony default export */ var SlideModal = (SlideModalComponent);
// EXTERNAL MODULE: ./src/components/atom/SearchComponent/SearchComponent.jsx
var SearchComponent = __webpack_require__(53702);
// EXTERNAL MODULE: ./src/components/molecules/GameSearchComponent/stores/useGameSearchComponentStore.store.js
var useGameSearchComponentStore_store = __webpack_require__(38451);
// EXTERNAL MODULE: ./src/components/molecules/Card/CardGame/index.jsx + 1 modules
var CardGame = __webpack_require__(5231);
// EXTERNAL MODULE: ./context/store/useNavbarStore.store.js
var useNavbarStore_store = __webpack_require__(18963);
// EXTERNAL MODULE: ./context/store/useGameStore.store.js
var useGameStore_store = __webpack_require__(86568);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./src/components/molecules/GameSearchComponent/components/GameSearchPageComponent2/index.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var initGames = {
  totalGames: 0,
  gameData: []
};

var GameSearchPageComponent2 = function GameSearchPageComponent2() {
  var _games$gameData;

  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useGameStore = (0,useGameStore_store/* default */.Z)(function (state) {
    return {
      allGameData: state.allGameData
    };
  }),
      allGameData = _useGameStore.allGameData;

  var _useGameSearchCompone = (0,useGameSearchComponentStore_store/* default */.Z)(function (state) {
    return {
      openSearchGamePage: state.openSearchGamePage,
      onSearch: state.onSearch,
      setCloseSearchGamePage: state.setCloseSearchGamePage,
      setOnSearch: state.setOnSearch,
      setClearOnSearch: state.setClearOnSearch
    };
  }),
      openSearchGamePage = _useGameSearchCompone.openSearchGamePage,
      onSearch = _useGameSearchCompone.onSearch,
      setCloseSearchGamePage = _useGameSearchCompone.setCloseSearchGamePage,
      setOnSearch = _useGameSearchCompone.setOnSearch,
      setClearOnSearch = _useGameSearchCompone.setClearOnSearch;

  var _useNavbarStore = (0,useNavbarStore_store/* default */.Z)(function (state) {
    return {
      setOpenNavbar: state.setOpenNavbar
    };
  }),
      setOpenNavbar = _useNavbarStore.setOpenNavbar;

  var _useState = (0,react.useState)(initGames),
      games = _useState[0],
      setGames = _useState[1];

  var _useState2 = (0,react.useState)(0),
      totalGames = _useState2[0],
      setTotalGames = _useState2[1];

  var _useState3 = (0,react.useState)(100),
      displayCount = _useState3[0],
      setDisplayCount = _useState3[1];

  var itemsToDisplay = (_games$gameData = games.gameData) === null || _games$gameData === void 0 ? void 0 : _games$gameData.slice(0, displayCount);
  (0,react.useEffect)(function () {
    setGames(_objectSpread(_objectSpread({}, games), {}, {
      gameData: allGameData === null || allGameData === void 0 ? void 0 : allGameData.body
    }));
    setTotalGames(allGameData === null || allGameData === void 0 ? void 0 : allGameData.total);
  }, [allGameData]);

  var changeGamesPayload = function changeGamesPayload() {
    setDisplayCount(function (prevCount) {
      return prevCount + 100;
    });
  };

  var searchGames = function searchGames() {
    var _allGameData$body;

    var searchTerm = onSearch.toLowerCase();
    var newSearchGameData = allGameData === null || allGameData === void 0 ? void 0 : (_allGameData$body = allGameData.body) === null || _allGameData$body === void 0 ? void 0 : _allGameData$body.filter(function (game) {
      return game.gn.toLowerCase().includes(searchTerm) || game.pi.toLowerCase().includes(searchTerm) || game.cn.toLowerCase().includes(searchTerm) || game.pn.toLowerCase().includes(searchTerm);
    }); // Reset display count when new search is made

    setDisplayCount(100);
    setTotalGames(newSearchGameData === null || newSearchGameData === void 0 ? void 0 : newSearchGameData.length);
    setGames(_objectSpread(_objectSpread({}, games), {}, {
      gameData: newSearchGameData
    }));
  };

  var onCloseSearchGamePageComponent = function onCloseSearchGamePageComponent() {
    setGames(_objectSpread(_objectSpread({}, games), {}, {
      gameData: allGameData === null || allGameData === void 0 ? void 0 : allGameData.body
    }));
    setClearOnSearch();
    setOpenNavbar();
    setCloseSearchGamePage();
  };

  var getSearchGame = function getSearchGame() {
    if (onSearch && onSearch !== '') {
      searchGames();
    } else {
      // Reset display count when search is cleared
      setDisplayCount(100);
      setGames(_objectSpread(_objectSpread({}, games), {}, {
        gameData: allGameData === null || allGameData === void 0 ? void 0 : allGameData.body
      }));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SlideModal, {
    isOpen: openSearchGamePage,
    title: "Cari Game",
    onClose: onCloseSearchGamePageComponent,
    slideMode: "fromBottom",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "space-y-section",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SearchComponent/* default */.Z, {
        gradientBorder: true,
        placeholder: t('text.searchFavoriteGame'),
        value: onSearch,
        onChange: setOnSearch,
        onSearch: getSearchGame
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-2",
        children: itemsToDisplay.map(function (game, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardGame["default"], {
            game: game
          }, `${game === null || game === void 0 ? void 0 : game.gpId}-${game === null || game === void 0 ? void 0 : game.gpGameId}-${index}`);
        })
      }), totalGames > displayCount && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-center cursor-pointer text-container-color-primary",
          onClick: changeGamesPayload,
          children: "Click to load more games"
        })
      })]
    })
  });
};

/* harmony default export */ var components_GameSearchPageComponent2 = (GameSearchPageComponent2);

/***/ }),

/***/ 38451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var _require = __webpack_require__(14671),
    create = _require.create;

var useGameSearchComponentStore = create(function (set) {
  return {
    openSearchGamePage: false,
    onSearch: '',
    setOpenSearchGamePage: function setOpenSearchGamePage() {
      set({
        openSearchGamePage: true
      });
    },
    setCloseSearchGamePage: function setCloseSearchGamePage() {
      set({
        openSearchGamePage: false
      });
    },
    setOnSearch: function setOnSearch(onSearch) {
      set({
        onSearch: onSearch
      });
    },
    setClearOnSearch: function setClearOnSearch() {
      set({
        onSearch: ''
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useGameSearchComponentStore);

/***/ }),

/***/ 99125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ customImageLoader; }
/* harmony export */ });
var customImageLoader = function customImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return `${src}?w=${width}&q=${quality || 50}`;
}; // const customLoader = ({ src, width, quality }) => {
// 	return `${src}?w=${width}&q=${quality || 75}`;
// };
// export default customLoader;

/***/ }),

/***/ 8957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90512);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27154);


function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }

  return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}

/***/ }),

/***/ 75774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ animationVariants; }
/* harmony export */ });
var animationVariants = {
  fromRight: {
    open: {
      x: 0,
      opacity: 1
    },
    closed: {
      x: '100%',
      opacity: 0
    }
  },
  fromLeft: {
    open: {
      x: 0,
      opacity: 1
    },
    closed: {
      x: '-100%',
      opacity: 0
    }
  },
  fromTop: {
    open: {
      y: 0,
      opacity: 1
    },
    closed: {
      y: '-100%',
      opacity: 0
    }
  },
  fromBottom: {
    open: {
      y: 0,
      opacity: 1
    },
    closed: {
      y: '100%',
      opacity: 0
    }
  },
  fadeAndTransform: {
    hidden: {
      opacity: 0,
      y: '-100%'
    },
    // Initial hidden state
    visible: {
      opacity: 1,
      y: 0
    } // Visible state with transform

  },
  easeInOut: {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1
    }
  }
};

/***/ })

}]);